module.exports = __webpack_public_path__ + "media/video_circos_do_brasil.6ec9f6a6.mp4";